<template>
  <div class="home">
    <div class="absolute align-middle bottom-0 right-0">
      <router-link
        to="#beranda"
        class="flex justify-center md:justify-start my-2"
      >
        <svg
          v-show="visible"
          id="backToTopID"
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="50"
          fill="currentColor"
          class="bi bi-arrow-up-circle-fill text-cLightBlue fixed z-50 right-0 object-right -mt-16 mr-1 px-2 md:px-0 md:mr-6 md:-mt-20 xl:-mt-16 xl:p-1 2xl:-mt-24 2xl:mr-4 cursor-pointer"
          viewBox="0 0 16 16"
          @click="scrollToTop"
        >
          <path
            d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"
          />
        </svg>
      </router-link>
    </div>
    <Beranda />
    <About />
    <Program />
    <Cara />
    <Donasi />
  </div>
</template>

<script>
import Beranda from "@/components/Beranda.vue";
import About from "@/components/About.vue";
import Program from "@/components/Program.vue";
import Cara from "@/components/Cara.vue";
import Donasi from "@/components/Donasi.vue";

export default {
  name: "Home",
  components: {
    Beranda,
    About,
    Program,
    Cara,
    Donasi,
  },
  data() {
    return {
      visible: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.getIcon);
  },
  destroyed() {
    window.removeEventListener("scroll", this.getIcon);
  },
  methods: {
    getIcon(event) {
      if (event.path[1].pageYOffset < 100) {
        this.visible = false;
      } else {
        this.visible = true;
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
